import { render } from "./NoticeModal.vue?vue&type=template&id=7fd8e456&scoped=true&ts=true"
import script from "./NoticeModal.vue?vue&type=script&lang=ts"
export * from "./NoticeModal.vue?vue&type=script&lang=ts"

import "./NoticeModal.vue?vue&type=style&index=0&id=7fd8e456&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd8e456"]])

export default __exports__